module.exports = __webpack_public_path__ + "media/images/modules/root_on_talkport/step2-ef5ada0445ff15f00d7b80055a0164f7.png";